<template>
  <div class="p-grid">
    <center>
      <div class="p-col maxwidth">
        <img
          class="pointer"
          width="64px"
          style="transform: scale(1.75); padding-left: 5px"
          src="../../public/assets/layout/images/pmg-shops.png"
          @click="goLogin()"
        />
        <img
          class="pointer"
          width="220px"
          style="padding-left: 7px"
          src="../../public/assets/layout/images/pmg-logo-white.png"
          @click="goLogin()"
        />
      </div>

      <div class="p-col-12 p-lg-10">
        <div class="card">
          <h4><b>Terms and Conditions for PLACE MUST GO</b></h4>
          <h5>Effective: March 01, 2022</h5>
          <p align="left">
            These Terms and Conditions (the "Terms and Conditions") are the
            terms and conditions for using <b>PLACE MUST GO</b> in both the
            website and smartphone mobile applications (hereinafter referred to
            as "PLACE MUST GO"), which are provided by<br /><b
              >Thai Digital Map Co.,Ltd.</b
            >
            with office located at 63 Sukhumvit Soi 68, Sukhumvit Road, Bang Na
            Nuea, Bangna, Bangkok 10260 (hereinafter referred to as"<b>TDM</b>")
            Please read the terms and conditions, including the
            <b>TDM</b> Privacy Policy, in detail. Your choice to "accept" is the
            assurance that you have read it, understand and agree to be bound to
            these terms and conditions, including the <b>TDM</b> Privacy Policy,
            and acknowledge that I am able to withdraw my consent for
            collection, use and disclosure of personal information in accordance
            with this document at any time by submitting the request as per
            channels set out in the <b>TDM</b> Privacy Policy mentioned above.
          </p>
          <Accordion>
            <AccordionTab header="1. Definition" :active="false">
              <p align="left">
                <b>In these Terms and Conditions, the following words mean:</b
                ><br />
                1.1) The User refers to the person who agrees to this Terms and
                Conditions.<br />
                <br />1.2) The User's ID means the identity received and
                provided through the registration to use
                <b>PLACE MUST GO</b>.<br />
                <br />1.3) <b>PLACE MUST GO</b> means relevant and content
                provided and accessed through the website
                <a href="http://pmg.dtc.co.th:3000"
                  ><u>http://pmg.dtc.co.th:3000</u></a
                >
                and/or the <b>PLACE MUST GO</b> application on a smartphone (as
                defined below), whether it is paid or free of charge.<br />
                <br />1.4) Smart phone or other communication devices which
                support the installation and access of
                <b>PLACE MUST GO</b>.<br />
                <br />
                1.5) GPS refers to electronic devices that identify
                geo-coordinates and statuses.
              </p>
            </AccordionTab>

            <AccordionTab
              header="2. Changes to terms and conditions and/or PLACE MUST GO"
            >
              <p align="left">
                2.1) <b>TDM</b> has the right to amend this Terms and Conditions
                at any time. In so doing, new terms and conditions will be
                presented to you for your acceptance through the website or
                mobile application on a smartphone. Once you have accepted these
                terms and conditions, the new terms and conditions shall be
                effective immediately or as specified in such terms or
                conditions. If you do not agree to the new terms and conditions,
                you can refuse to accept such terms and conditions. However,
                such refusal may affect the use of certain <b>PLACE MUST GO</b>,
                including the requirement to stop using <b>PLACE MUST GO</b> and
                remove the application on your smartphone mobile phone
                immediately at the end of your existing
                <b>PLACE MUST GO</b> period.<br />
                <br />2.2) <b>TDM</b> can add, remove, or modify
                <b>PLACE MUST GO</b>, in part or in whole, immediately without
                prior notification.<br />
                <br />2.3) <b>TDM</b> may occasionally update the information on
                Place Must Go and/or smartphone mobile application. Such
                information updates are intended for the purpose of improving
                and/or developing additional <b>PLACE MUST GO</b> and/or
                reducing defects or malfunctions. In relation to such updates,
                minimum technical standards may be changed from time to time.
              </p>
            </AccordionTab>

            <AccordionTab header="3. Using PLACE MUST GO">
              <p align="left">
                3.1) Some are only available on the website. Some are only
                available in the smartphone mobile application, and others are
                available on both channels.<br />
                <br />3.2) In using <b>PLACE MUST GO</b>, you must first
                complete registration for the <b>PLACE MUST GO</b> , which
                involves creating a user ID and password, as well as access
                rights to the website and application.<br />
                <br />3.3) <b>PLACE MUST GO</b>'s multiple depend on mobile data
                communication and/or GPS, whether via a smartphone or GPS/DVR.
                <b>PLACE MUST GO</b> operations rely on your mobile network
                operator and many <b>PLACE MUST GO</b> will not be available or
                may be of reduced quality in the following situations:<br />
                <br />&nbsp; &nbsp;3.3.1) Smartphone or GPS does not have good
                network reception.<br />
                <br />&nbsp; &nbsp;3.3.2) from mobile network operator is
                restricted or terminated, for example due to high-speed internet
                data running out.<br />
                <br />&nbsp; &nbsp;3.3.3) GPS signal level is not sufficient in
                certain areas.
              </p>
            </AccordionTab>

            <AccordionTab header="4. User Responsibility">
              <p align="left">
                4.1) You must keep the user ID and password for
                <b>PLACE MUST GO</b> confidential. You must not allow any other
                persons to use your user ID, and you must not use the user ID of
                any other persons. You are responsible for all actions and
                consequences arising from the use of your user ID, regardless of
                whether the act was committed by you or any other persons.<br />
                <br />4.2) If you transfer or provide smartphones with PLACE
                MUST GO application installed to third parties, you are
                responsible for uninstalling <b>PLACE MUST GO</b> application
                from those devices immediately.<br />
                <br />4.3) If you receive a smartphone with such application
                from a third party and you wish to use <b>PLACE MUST GO</b>, you
                must sign in using your own user ID and password, and you must
                not use any other person's information or credentials.<br />
                <br />4.4) When you have changed your contact information,
                including but not limited to phone numbers, addresses and or
                emails, you must notify <b>TDM</b> immediately.<br />
                <br />4.5) You must comply with all applicable laws when using
                <b>PLACE MUST GO</b>.
              </p>
            </AccordionTab>

            <AccordionTab header="5. Equipment Responsibility">
              <p align="left">
                5.1) If you use the <b>PLACE MUST GO</b> application on a
                smartphone, you are responsible for the mobile smartphone, its
                operating system, settings, third-party software installed on
                the smartphone and third-party accessories installed on the
                smartphone. The application requires data connection from your
                mobile operator and GPS to work properly. Therefore, please set
                appropriate permissions and do not use the application on a
                smartphone mobile phone that has been jailbroken or rooted
                because such devices may interfere with the normal operation of
                this application.<br />
                <br />5.2) You are responsible for any contracts made with your
                mobile operator as necessary to use <b>PLACE MUST GO</b> ,
                including but not limited to adequate and availability of use of
                high-speed data.<br />
              </p>
            </AccordionTab>

            <AccordionTab header="6. Temporarily suspending PLACE MUST GO">
              <p align="left">
                <b>TDM</b> may occasionally cease or restrict
                <b>PLACE MUST GO</b>, regardless whether with or without prior
                notification. Situations where <b>TDM</b> may temporarily stop
                or restrict <b>PLACE MUST GO</b> are as following examples:<br />
                <br />6.1) Maintenance of <b>PLACE MUST GO</b> systems, whether
                scheduled or not.<br />
                <br />6.2) Force majeure causes such as floods, storms, fires,
                power outages, earthquake, volcanic eruptions, tsunamis, wars,
                insurgency or plagues, etc. that affect
                <b>PLACE MUST GO</b> systems.<br />
                <br />6.3) Workers' strike marches or strikes affecting PLACE
                MUST GO systems.<br />
                <br />6.4) Data connectivity issues that occur between PLACE
                MUST GO and third-party networks<br />
                <br />6.5) Technical or other operational issues affecting
                <b>TDM</b>'s ability to provide <b>PLACE MUST GO</b><br />
              </p>
            </AccordionTab>

            <AccordionTab header="7. Intellectual Property">
              <p align="left">
                7.1) <b>TDM</b> owns the copyright, patent, trademark, trade
                secrets and or any right to ownership or all intellectual
                property benefits in the service provision of
                <b>PLACE MUST GO</b>, including the website and application on
                smartphones, whether they are present in the form of patents,
                trademarks, copyrights, trade secrets or other forms of
                intellectual property, whether registered or unregistered
                (collectively referred to as "PLACE MUST GO intellectual
                property").<br />
                <br />7.2) In accordance with these Terms and Conditions, you
                have limited permission and you are unable to transfer the right
                to use intellectual property relating to <b>PLACE MUST GO</b>,
                which is your right only for your personal or organizational use
                in accordance with your plan of services that is still valid.
                All other uses are prohibited. You have no intellectual property
                rights whatsoever related to <b>PLACE MUST GO</b>.<br />
                <br />7.3) You shall not reproduce, modify, change, amend,
                reverse engineer, sell, propose to sell, rent, lease, distribute
                or transfer intellectual property rights relating to PLACE MUST
                GO, and you shall not authorize or grant proxies or allow any
                third party to exercise or act in any intellectual property
                related to <b>PLACE MUST GO</b>.
              </p>
            </AccordionTab>

            <AccordionTab header="8. Reparations and Limitations of Liability">
              <p align="left">
                8.1) If you break these Terms and Conditions, you agree and
                consent to indemnify <b>TDM</b> fully for all damages or claims
                retributed to <b>TDM</b> that may result from any action.<br />
                <br />8.2) <b>TDM</b> is not responsible in any way with respect
                to the following:<br />
                <br />&nbsp; &nbsp;8.2.1) Problems with third-party network
                operations<br />
                <br />
                &nbsp; &nbsp;8.2.2) Problemswith your device, either relating to
                smartphone or any mobile operator’s services.<br />
                <br />&nbsp; &nbsp;8.2.3) Your failure to notify <b>TDM</b> of
                theupdate of your personal data. 8.2.4) Your failure to comply
                with these Terms and Conditions in any way.<br />
              </p>
            </AccordionTab>

            <AccordionTab header="9. Termination of Contract">
              <p align="left">
                9.1) <b>TDM</b> may exercise the right to terminate your right
                to use <b>PLACE MUST GO</b> by notice with immediate effect in
                the event that you breach the essence of these Terms and
                Conditions, including but not limited to such as failure to pay
                for the service or any breach of these Terms and Conditions
                regarding intellectual property matters related to
                <b>PLACE MUST GO</b>.<br />
                <br />9.2) The Terms and Conditions regarding the intellectual
                property of <b>PLACE MUST GO</b>, personal data, reparations and
                limitation of liability shall continue to apply even after the
                end and or termination of these Terms and Conditions.<br />
              </p>
            </AccordionTab>

            <AccordionTab header="10. Notice">
              <p align="left">
                If you wish to contact the company, you can do this by sending
                an email to
                <a href="mailto:tdm@tdm.in.th">tdm@tdm.in.th</a>
              </p>
            </AccordionTab>

            <AccordionTab header="11. Applicable Laws and General Requirements">
              <p align="left">
                These Terms and Conditions are governed by Thai law.<br />
                <br />&nbsp; &nbsp;These Terms and Conditions are all agreements
                between the parties. In relation to the terms and conditions of
                use of <b>PLACE MUST GO</b> if one of these Terms is incomplete
                or cannot be enforced, the remaining terms and conditions shall
                be fully applicable and the User cannot transfer their rights or
                assign their duties to any third party without prior
                <b>TDM</b> letter consent.
              </p>
            </AccordionTab>
          </Accordion>
        </div>
      </div>

      <div class="p-col-12 p-lg-10">
        <div class="card">
          <h4><b>Cookies Policy</b></h4>
          <Accordion>
            <AccordionTab header="1. Definition" :active="false">
              <p align="left">
                Cookies are small text files that are downloaded to your
                computer or mobile device. This saves information and settings
                such as saving language settings on your device, recording your
                current access status to help you continue to access websites
                and/or applications (collectively, "Services"), as well as
                collect information about your history of access to your
                favorite services in file format.
              </p>
            </AccordionTab>

            <AccordionTab header="2. Benefits of cookies" :active="false">
              <p align="left">
                Cookies tell
                <b>Thai Digital Map Co.,Ltd.</b> (collectively,"<b>TDM</b>") to
                know which parts of the <b>TDM</b> service you access so that
                <b>TDM</b> can provide a better service experience that meets
                your needs. In addition, saving the first setting of the service
                with cookies will allow you to access the service with a set
                value every time you use it, except in the event that the cookie
                is deleted, which returns all settings to the default.
              </p>
            </AccordionTab>

            <AccordionTab header="3. Use of cookies" :active="false">
              <p align="left">
                <b>TDM</b> uses cookies and other technologies such as
                pixel-tags on <b>TDM</b> services (collectively, "services that
                refer to cookie policies"), so any services you use to access
                services that refer to cookie policies shall receive cookies
                from <b>TDM</b>. When you access a service that refers to the
                Cookie Policy, <b>TDM</b> cookies will be downloaded to your
                device to store information about usage patterns and usage
                history. Information or services of interest to you, including
                your latest access reference number, etc. In addition to that,
                <b>TDM</b> shares cookies in conjunction with pixel-tag
                technology to know the usage patterns and usage history of the
                service as well as Information or services that interest you and
                analyze them to improve the provision of services, display
                content, advertisements, or promote appropriate activities and
                services that match your interests to increase your
                satisfaction. However, <b>TDM</b> will use cookies under the
                details outlined in the Privacy Notice.<br /><b
                  ><br />For the types of cookies that <b>TDM</b> uses, they can
                  be categorized as follows:</b
                ><br />

                <br />&nbsp; &nbsp;3.1 Service cookies Service cookies allow you
                to use the services and/or access functions such as cookies that
                manage logins and your login status.<br />
                <br />&nbsp; &nbsp;3.2 Cookies that enhance the use of the
                service Cookies that enhance the use of the service will
                facilitate you to use the service and help <b>TDM</b> get to
                know you better.<br />

                <br /><b
                  >Examples of facilitating you to use this type of cookie
                  are:</b
                ><br />

                <br />&nbsp; &nbsp;- Remembering the status of the service, such
                as the language selection. <br />&nbsp; &nbsp;- Remembering the
                answers you've answered before, which will help you not to
                answer the same questions again. <br />&nbsp; &nbsp;- LiveChat
                available on the <b>TDM</b> website. <br />&nbsp; &nbsp;-
                Providing social media sharing functionality that allows you to
                share content of interest on social networks.<br />

                <br />&nbsp; &nbsp;For the purpose of providing services and to
                facilitate you to use the services as in the examples above,
                <b>TDM</b>
                uses plugins and third-party services such as Google Analytics,
                Facebook Analytics, Truehits, Hotjars, Facebook, Line, Twitter,
                and AddThis.
              </p>
            </AccordionTab>

            <AccordionTab header="4. How to disable cookies" :active="false">
              <p align="left">
                You can disable cookies by setting up your browser and setting
                privacy settings to suppress future data collection by cookies.
                However, some services on the <b>TDM</b> website require the use
                of cookies. If you disable cookies, you may not be able to use
                certain or all of the functions of such services smoothly
              </p>
            </AccordionTab>
          </Accordion>
        </div>
      </div>
    </center>
  </div>
</template>

<script>
export default {
  data() {},
  methods: {
    goLogin() {
      window.location = "/login";
    },
  },
};
</script>

<style scoped>
</style>
